import React, { Component, useState, useEffect, useRef } from "react";
import Axios from "axios";
//remember, have to replace data-feather with font awesome icons
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link, useParams, useLocation } from "react-router-dom";
import ReactToPrint from "react-to-print";
import Select from "react-select";
import html2canvas from "html2canvas";
import { v4 as uuidv4 } from "uuid";
import dayjs from "dayjs";
import { Row, Col, Card, Dropdown, Button, Typography, Drawer, Modal, Input, Space } from "antd";
import { faArrowAltCircleLeft, faClock, faEdit, faEnvelope, faPaperPlane, faPrint, faTasks, faUserCircle } from "@fortawesome/free-solid-svg-icons";

function BulkInvoicePreview(props) {
  let { state } = useLocation();
  const [invoices, setInvoices] = useState(null);
  const [company, setCompany] = useState(null);
  const [imageRefresher, setImageRefresher] = useState(uuidv4());

  const printableRef = useRef();

  const GetInvoices = async () => {
    let response = await props.AxiosRequest("/api/invoices/get-bulk", { ids: state.invoices });
    setInvoices(response.data.invoices);
  };
  const GetCompany = async () => {
    let response = await props.AxiosRequest("/api/companies/get");
    setCompany(response.data.company);
  };

  useEffect(() => {
    GetInvoices();
    GetCompany();
  }, []);

  return (
    <>
      <div className="container">
        <Row gutter={[16, 16]} className="mt-2 mb-4">
          <Col span={8} className="text-center">
            {/* <Dropdown
            menu={{
              items: [
                {
                  key: 0,
                  label: (
                    <Link to={"/invoicing/" + invoice?.tag}>
                      <FontAwesomeIcon icon={faEdit} className="mr-1" />
                      To Invoice
                    </Link>
                  ),
                },
                {
                  key: 1,
                  label: (
                    <Link to={"/client-details/" + invoice?.clients_tag}>
                      <FontAwesomeIcon icon={faUserCircle} className="mr-1" />
                      To Client
                    </Link>
                  ),
                },
                {
                  key: 2,
                  label: (
                    <Link to={{ pathname: "/time-sheet" }}>
                      <FontAwesomeIcon icon={faClock} className="mr-1" />
                      To Time Sheet
                    </Link>
                  ),
                },
                {
                  key: 3,
                  label: (
                    <Link to={{ pathname: "/task-board" }}>
                      <FontAwesomeIcon icon={faTasks} className="mr-1" />
                      To My Board
                    </Link>
                  ),
                },
              ],
            }}
          >
            <Button>
              <FontAwesomeIcon icon={faArrowAltCircleLeft} className="pe-none mr-2" />
              Go Back
            </Button>
          </Dropdown> */}
          </Col>
          <Col span={8} className="text-center">
            <ReactToPrint
              trigger={() => (
                <Button>
                  <FontAwesomeIcon icon={faPrint} className="mr-1" /> Bulk Print Invoices
                </Button>
              )}
              content={() => printableRef.current}
            />
          </Col>
          <Col span={8} className="text-center"></Col>
        </Row>
        <div className="d-flex justify-content-center">
          <div style={{ width: "210mm", minHeight: "260mm", margin: "auto", pageBreakAfter: "auto" }} ref={printableRef}>
            {invoices?.map((invoice) => (
              <div className="invoice-body mb-3">
                <Card style={{ pageBreakAfter: "always", minHeight: "75vh" }}>
                  <Row gutter={[16, 16]}>
                    <Col span={10} style={{ display: "flex", alignItems: "center", fontSize: "14px" }}>
                      <div style={company?.invoice_image_type === 1 ? { maxWidth: "100%", display: "inline-block" } : { maxWidth: "105px", display: "inline-block" }}>
                        {company?.image_link ? (
                          <img
                            crossOrigin="anonymous"
                            src={"https://firmtamer-public-bucket.s3.amazonaws.com/" + company?.image_link + "?v=" + imageRefresher}
                            style={company?.invoice_image_type === 1 ? { maxWidth: "100%", maxHeight: "99%" } : { maxWidth: "95px", maxHeight: "99%" }}
                            id="user-info-image"
                            className="img-fluid mb-2"
                            alt="User"
                            onError={() => {
                              setImageRefresher(uuidv4());
                            }}
                          />
                        ) : null}
                      </div>
                      <div style={{ display: "inline-block", marginLeft: "15px" }}>
                        <b>{company?.name ? company?.name : null}</b>
                        <br></br>
                        {company?.address_line_1 ? company?.address_line_1 : null}
                        <br></br>
                        {company?.address_line_2 === "" ? company?.address_line_2 : null}
                        {company?.city}, {company?.state} {company?.zip}
                        <br></br>
                      </div>
                    </Col>
                    <Col span={4}>
                      <Typography.Title level={3}>INVOICE</Typography.Title>
                    </Col>
                    <Col span={4} className="text-md-end" style={{ textAlign: "right !important", fontSize: "12px" }}>
                      <div>
                        <b>Telephone:</b>
                        <br></br>
                        <b>Fax:</b>
                        <br></br>
                        <b>Website:</b>
                        <br></br>
                        <br></br>
                        <br></br>
                        <b>Invoice:</b>
                        <br></br>
                        <b>Invoice Date:</b>
                        <br></br>
                        <b>Due Date:</b>
                      </div>
                    </Col>
                    <Col span={6} className="text-md-end" style={{ fontSize: "12px" }}>
                      <div>{company?.telephone || <br />}</div>
                      <div>{company?.fax || <br />}</div>
                      <div>{company?.website || <br />}</div>
                      <br></br>
                      <br></br>
                      <div>{invoice?.id === -1 ? "Not yet saved" : <strong># {invoice?.name}</strong>}</div>
                      <div>{props.MakeDateTimeReadable(invoice?.invoiced_at)}</div>
                      <div>{props.MakeDateTimeReadable(invoice?.due_at)}</div>
                    </Col>
                  </Row>
                  {console.log(invoice)}
                  <hr className="my-4"></hr>
                  <div className="row mb-4" style={{ marginLeft: ".9in" }}>
                    <div className="col-md-6">
                      <strong>{invoice?.client?.name}</strong>
                      <p>
                        {invoice?.client?.address_line_1}
                        <br></br>
                        {invoice?.client?.address_line_2 === "" ? null : (
                          <span>
                            {invoice?.client?.address_line_2}
                            <br></br>
                          </span>
                        )}
                        {invoice?.client?.city ? invoice?.client?.city + ", " + invoice?.client?.state + " " + invoice?.client?.zip : ""}
                        <br></br>
                      </p>
                    </div>
                    <div className="col-md-6 text-md-end"></div>
                  </div>
                  <table className="table table-sm">
                    <thead>
                      <tr>
                        <th>Description</th>
                        <th className="text-end">Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {invoice.line_items.map((e, i) => {
                        return (
                          <tr key={i}>
                            <td>{e.item_description}</td>
                            <td className="text-end">{props.FormatNumberToCurrency(e.total)}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                    <tfoot>
                      <tr>
                        <th>Total:</th>
                        <th className="text-end">{invoice.line_items.length > 0 ? props.FormatNumberToCurrency(invoice.line_items.reduce((a, b) => a + b.total, 0)) : null}</th>
                      </tr>
                    </tfoot>
                  </table>
                  <div
                    className="text-center"
                    dangerouslySetInnerHTML={{
                      __html:
                        company?.invoice_footer_text ||
                        `<p className="text-sm">
                          <strong>Thank you for your business!</strong>
                        </p>`,
                    }}
                  ></div>
                </Card>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default BulkInvoicePreview;
